import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';
@Injectable({
  providedIn: 'root',
})
export class IPTService {
  constructor(private gqlclient: GraphQLClient) {}

  listaIPT(callback: Function) {
    const respuesta = {
      registros: [
        { codigo: 1, descripcion: 'Lunes' },
        { codigo: 2, descripcion: 'Martes' },
        { codigo: 3, descripcion: 'Miercoles' },
        { codigo: 4, descripcion: 'Jueves' },
        { codigo: 5, descripcion: 'Viernes' },
        { codigo: 6, descripcion: 'Sabado' },
        { codigo: 7, descripcion: 'Domingo' },
      ],
    };
    callback({ respuesta });
  }

  obtenerCoberturaIPTResumen(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: ipt_vendedor_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            ipt_vendedor_cliente {
              obtenerSegunCoberturaIPTResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    vendedor_codigo
                    vendedor_nombre
                    numero_pedido
                    total_neto
                    total_cliente_vendedor
                    total_cliente
                    clientesConPedidos
                    numero_pedido
                    coberturaClientes
                    coberturaVentas
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.obtenerSegunCoberturaIPTResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerCoberturaIPTResumenExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: ipt_vendedor_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            ipt_vendedor_cliente {
              obtenerSegunCoberturaIPTResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.obtenerSegunCoberturaIPTResumen;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerCoberturaIPTDetalle(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: ipt_vendedor_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            ipt_vendedor_cliente {
              obtenerSegunCoberturaIPTDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    cliente_proveedor_rut
                    cliente_nombre
                    comuna
                    direccion_completa
                    vendedor_codigo
                    sucursal_codigo
                    estado_cliente
                    lunes
                    martes
                    miercoles
                    jueves
                    viernes
                    sabado
                    domingo
                    activo
                    numero_pedido
                    total_neto
                    fecha_emision
                    total_cliente
                    codsuclegacy
                    secuencia
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.obtenerSegunCoberturaIPTDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }

  obtenerCoberturaIPTDetalleExcel(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
          query ($entidad: ipt_vendedor_clienteInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            ipt_vendedor_cliente {
              obtenerSegunCoberturaIPTDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.ipt_vendedor_cliente.obtenerSegunCoberturaIPTDetalle;
        callback({ mensajes, respuesta });
      }
    );
  }
}
